// extracted by mini-css-extract-plugin
export default {"profile__image":"ProfileImage_profile__image__ZfbwX"};